import React from "react";

import { makeBEM } from "utils";

import "./index.scss";

export interface AlertProps {
  icon?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  variant?: "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "dark";
}

const bem = makeBEM("alert");

export const Alert: React.FC<AlertProps> = ({ icon, title, description, variant }) => {
  return (
    <div className={bem(null, [variant])}>
      {icon && <div className={bem("icon")}>{icon}</div>}
      <div className={bem("content")}>
        {title && <div className={bem("title")}>{title}</div>}
        {description && <div className={bem("description")}>{description}</div>}
      </div>
    </div>
  );
};
